import { useTranslator } from '@Localization';
import { Slider } from '@mui/joy';
import { ReactElement } from 'react';
import { ValidatedTextInput } from '../../../__legacy__/components/ValidatedTextInput';
import { ButtonWithLoader } from '../../../design/buttons/ButtonWithLoader';
import { S_FieldLabel } from '../../../design/labels/fieldLabel/S_FIeldLabel';

interface IProps {
  label: string;
  onChange?: (value: number) => void;
  value: number;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
}

export const SliderWithLabel = ({ label, onChange, ...props }: IProps): ReactElement => {
  let labelText = '';

  if (props.disabled) {
    labelText = label;
  } else {
    labelText = `${label}: ${props.value.toFixed(2)}`;
  }

  return (
    <div className='slider-wrapper'>
      <S_FieldLabel>{labelText}</S_FieldLabel>
      <Slider
        {...props}
        onChange={(_, v) => onChange?.(v as number)}
      />
    </div>
  );
};

interface ITwoSideSliderWithLabelProps {
  label: string;
  value: number[];
  onChange?: (value: readonly number[]) => void;
  onInputChanged?: (title: string) => (value: string) => void;
  inputsValues: { min: string; max: string };
  saveThresholdsHandler?: () => Promise<void>;
  isSaving?: boolean;
  min: number;
  max: number;
  step?: number;
  disabled?: boolean;
}

export const RecalculateMetricsSlider = ({
  label,
  onChange,
  onInputChanged,
  inputsValues,
  saveThresholdsHandler,
  isSaving,
  step,
  disabled,
  min,
  max,
  ...props
}: ITwoSideSliderWithLabelProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <div className='slider-container'>
      <div className='slider-wrapper'>
        <div className='label-container'>
          <ValidatedTextInput
            value={inputsValues.min}
            onChange={onInputChanged?.('min')}
            type='number'
            className='threshold-input'
            min={min}
            step={step}
            max={props.value[1] - 1}
            disabled={disabled}
          />
          <S_FieldLabel>{label}</S_FieldLabel>
          <ValidatedTextInput
            value={inputsValues.max}
            type='number'
            min={props.value[0] + 1}
            onChange={onInputChanged?.('max')}
            max={max}
            step={step}
            className='threshold-input'
            disabled={disabled}
          />
        </div>
        <Slider
          value={[parseFloat(inputsValues.min), parseFloat(inputsValues.max)]}
          onChange={(_, v) => {
            onChange?.(v as number[]);
          }}
          step={step}
          disabled={disabled}
          min={min}
          max={max}
        />
      </div>
      {!!saveThresholdsHandler && (
        <div className='button-container'>
          <ButtonWithLoader
            onClick={saveThresholdsHandler}
            loading={isSaving}
            color='primary'
            disabled={disabled}
          >
            {t('save')}
          </ButtonWithLoader>
        </div>
      )}
    </div>
  );
};
